export type MockStage = {
  id: string;
  name: string;
  createdAt?: Date;
  updatedAt?: Date;
  isDone?: boolean;
};

export type MockCard = {
  id: string;
  name: string;
  description?: string;
  price?: number;
  status?: string;
  createdAt?: Date;
  updatedAt?: Date;
  stageId: string;
};

export type MockStageSummary = {
  aggregationData?: { values: any };
};
